import React from "react";
import { Modal, Button } from "react-bootstrap";

const ModalUtil = ({ show, handleClose, titulo, children, size, onSave }) => {
  const handleSubmit = async () => {
    if (onSave) {
      const result = await onSave();
      if (result) {
        handleClose();
      }
    } else {
      handleClose();
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size={size || null} 
    >
      <Modal.Header closeButton>
        <Modal.Title>{titulo}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export { ModalUtil };
